import { render } from "./RuleTutorialView.vue?vue&type=template&id=784327ce"
import script from "./RuleTutorialView.vue?vue&type=script&lang=js"
export * from "./RuleTutorialView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\police-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__